import React from 'react';

import { ModalUtils } from '@/contexts/ModalWrapper';
import i18n from '@/languages/i18n';
import { UNKNOWN_ERROR_MESSAGE } from '@/config';
import { AppUrls } from '@/urls';

export const try2GetErrorMessage = (error: any) => {
  if (!error) {
    return UNKNOWN_ERROR_MESSAGE;
  }
  try {
    if (typeof error === 'object' && error.message) {
      return error.message;
    }
    return JSON.parse(new TextDecoder('utf-8').decode(error.response.data)).message || UNKNOWN_ERROR_MESSAGE;
  } catch (error) {
    return UNKNOWN_ERROR_MESSAGE;
  }
};
export const handleSubmitError = (error: any, onClose?: () => void) => {
  ModalUtils.error({
    title: 'Error!',
    content: <span>{i18n.t(try2GetErrorMessage(error))}</span>,
    onClose: onClose,
  });
};

export const handleApiUnKnowError = (error: any, onClose?: () => void) => {
  ModalUtils.error({
    title: 'Error!',
    content: <span>{i18n.t(try2GetErrorMessage(error))}</span>,
    onClose: onClose,
  });
};
export const handleBookingNotFound = () => {
  ModalUtils.error({
    title: 'Booking session not found!',
    content: (
      <span>
        We can not find this booking session, it may be expired or not exist. <br />
        Go to home page and you can search again!
      </span>
    ),
    onClose: () => {
      window.location.href = AppUrls.HomePage;
    },
  });
};

export const handleHotelNotFound = () => {
  ModalUtils.error({
    title: 'Hotel does not exist!',
    content: (
      <span>
        Hotel does not exist. <br />
        Go to home page and you can search again!
      </span>
    ),
    onClose: () => {
      window.location.href = AppUrls.HomePage;
    },
  });
};
